import React, { useState, useEffect } from 'react';
import { Modal, Form, DatePicker, Select } from 'antd';
import { useSelector } from 'react-redux';
import { SelectEmployee } from '../SelectInput';

const monthOptions = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

const PayslipModal = ({ visible, onCancel, onSubmit }) => {
  const [form] = Form.useForm();
  const [employeeId, setEmployeeId] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
  const { allEmployee } = useSelector((state) => state.employees);
  function removeDuplicatesByID(array) {
    const seen = new Set();
    return array.filter((item) => {
      if (seen.has(item.ID)) {
        return false;
      }
      seen.add(item.ID);
      return true;
    });
  }
  const filterData = removeDuplicatesByID(allEmployee)
  // Validate form fields dynamically
  const validateForm = async () => {
    try {
      await form.validateFields(['employeeId', 'month', 'year']);
      setIsFormValid(true);
    } catch (error) {
      setIsFormValid(false);
    }
  };

  // Trigger validation on form field changes
  useEffect(() => {
    if (visible) {
      validateForm();
    }
  }, [employeeId, form, visible]);

  const getEmpPayslip = () => {
    try {
      form.validateFields().then((values) => {
        if (!employeeId) {
          form.setFields([
            {
              name: 'employeeId',
              errors: ['Please select an employee'],
            },
          ]);
          return;
        }
        const formattedValues = {
          ...values,
          year: values?.year?.year?.() || new Date().getFullYear(),
          employeeId: employeeId,
        };
        onSubmit(formattedValues);
      });
    } catch (error) {
      console.warn('Form validation error:', error);
    }
  };

  return (
    <Modal
      title="Generate Pay Slip"
      open={visible}
      onOk={getEmpPayslip}
      onCancel={() => {
        form.resetFields();
        setEmployeeId(null);
        setIsFormValid(false);
        onCancel();
      }}
      okText="Generate"
      okButtonProps={{
        // Button is enabled only when isFormValid is true
      }}
    >
      <Form layout="vertical" form={form} onValuesChange={validateForm}>
        <Form.Item
          name="employeeId"
          label="Employee Name"
          rules={[{ required: true, message: 'Please select an employee' }]}
        >
          <SelectEmployee
            employeeList={filterData}
            onChange={(value) => {
              setEmployeeId(value);
              form.setFieldsValue({ employeeId: value }); // Sync form field
              validateForm();
            }}
            selectedEmployee={employeeId}
            customStyle="w-full"
            allLabel={{}}
          />
        </Form.Item>

        <Form.Item
          name="month"
          label="Month Name"
          rules={[{ required: true, message: 'Please select month' }]}
        >
          <Select
            options={monthOptions}
            placeholder="Select month"
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item
          name="year"
          label="Year"
          rules={[{ required: true, message: 'Please select year' }]}
        >
          <DatePicker
            picker="year"
            style={{ width: '100%' }}
            placeholder="Select year"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PayslipModal;